const markList = [
    {
        id: 40,
        markName: 'meituanwaimai_recharge',
    },
    {
        id: 86,
        markName: 'meituanwaimai_recharge',
    },
];

export default () => {
    return {
        computed: {
            mark() {
                const markObj = markList.find(item => item.id == this.id);
                if (markObj && markObj.markName) {
                    return markObj.markName;
                }
                return '';
            },
        },
    };
};
